/**
 * @generated SignedSource<<0cda408820b0ef5c83ebb0c5535127bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileCollection_viewer$data = {
  readonly collection: {
    readonly totalResults: number | null;
  } | null;
  readonly creations: {
    readonly totalResults: number | null;
  } | null;
  readonly draftItems?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftItemDraftsByCreatorEdge";
    } | null> | null;
  } | null;
  readonly liveAuctions: {
    readonly totalResults: number | null;
  } | null;
  readonly liveBids: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftAuctionsByBidderEdge";
    } | null> | null;
  } | null;
  readonly lostBids: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "NftAuctionsByBidderEdge";
    } | null> | null;
  } | null;
  readonly nftBenignNeglect: boolean | null;
  readonly tokenImports: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"importCollectionsConfig_contractImport">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_viewer" | "NftProfileCollectionNav_viewer" | "NftProfileImportCollectionList_viewer" | "NftProfileImportCollectionModal_viewer" | "NftProfileImportCollectionView_viewer" | "NftProfileSectionAuctions_viewer" | "NftProfileSectionCollection_viewer" | "NftProfileSectionCreations_viewer" | "NftProfileSectionDrafts_viewer" | "NftProfileSectionLiveBids_viewer" | "NftProfileSectionLostBids_viewer">;
  readonly " $fragmentType": "NftProfileCollection_viewer";
};
export type NftProfileCollection_viewer$key = {
  readonly " $data"?: NftProfileCollection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileCollection_viewer">;
};

import NftProfileCollectionQuery_graphql from './NftProfileCollectionQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v3 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v4 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "creatorAddress",
    "variableName": "walletAddress"
  },
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "collectionCursor"
    },
    {
      "kind": "RootArgument",
      "name": "collectionFirst"
    },
    {
      "kind": "RootArgument",
      "name": "creationsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "creationsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "draftsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "draftsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "fetchDrafts"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "hasTokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveAuctionsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "liveBidsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "lostBidsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "lostBidsFirst"
    },
    {
      "kind": "RootArgument",
      "name": "tokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    },
    {
      "kind": "RootArgument",
      "name": "walletAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftProfileCollectionQuery_graphql
    }
  },
  "name": "NftProfileCollection_viewer",
  "selections": [
    {
      "alias": "nftBenignNeglect",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftBenignNeglect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
    },
    {
      "alias": "creations",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "creatorAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "creatorAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "creatorProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "creatorProfileUsernames"
        },
        {
          "kind": "Literal",
          "name": "onlyFirstdibsContracts",
          "value": true
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "collection",
      "args": [
        (v2/*: any*/),
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "ownerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "ownerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "ownerProfileUsernames"
        }
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "liveAuctions",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerAddresses.0",
              "variableName": "walletAddress"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerAddresses"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "auctionSellerProfileUsernames.0",
              "variableName": "username"
            }
          ],
          "kind": "ListValue",
          "name": "auctionSellerProfileUsernames"
        },
        (v2/*: any*/)
      ],
      "concreteType": "NftItemSearchConnection",
      "kind": "LinkedField",
      "name": "nftItemSearch",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "liveBids",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "status",
          "value": "BIDDER_LIVE"
        },
        (v4/*: any*/)
      ],
      "concreteType": "NftAuctionsByBidderConnection",
      "kind": "LinkedField",
      "name": "nftAuctionsByBidder",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": "lostBids",
      "args": [
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "status",
          "value": "BIDDER_LOST"
        },
        (v4/*: any*/)
      ],
      "concreteType": "NftAuctionsByBidderConnection",
      "kind": "LinkedField",
      "name": "nftAuctionsByBidder",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "condition": "fetchDrafts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "draftItems",
          "args": (v7/*: any*/),
          "concreteType": "NftItemDraftsByCreatorConnection",
          "kind": "LinkedField",
          "name": "nftItemDraftsByCreator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItemDraftsByCreatorEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": (v5/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftProfileSectionDrafts_viewer"
        }
      ]
    },
    {
      "alias": "tokenImports",
      "args": (v7/*: any*/),
      "concreteType": "NftTokenContractImportsConnection",
      "kind": "LinkedField",
      "name": "nftTokenContractImports",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NftTokenContractImportsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftTokenContractImport",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "importCollectionsConfig_contractImport",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "importStatus",
                      "storageKey": null
                    },
                    {
                      "alias": "errored",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_ERROR"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                    },
                    {
                      "alias": "processing",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                    },
                    {
                      "alias": "completed",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "importStatuses",
                          "value": [
                            "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                          ]
                        }
                      ],
                      "concreteType": "NftTokenContractImportCreatedItemsConnection",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileSectionCollection_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileSectionAuctions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileSectionCreations_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileSectionLiveBids_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileSectionLostBids_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileCollectionNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionList_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionView_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftProfileImportCollectionModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "da62b1df8b8aaf0308dbd76c9e5f1827";

export default node;
